import { Store } from 'redux';

import { GlobalState } from 'ha/types/store';
import { getFeatureFlags } from 'ha/modules/FeatureFlags';
import { COUNTRIES_TRANSLATED } from 'ha/constants/countriesTranslated';
import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';
import UrlResolver from 'ha/helpers/UrlResolver';

import onEnterCountry from './onEnterCountry';
import { getIndexRouteCountry } from './getIndexRouteCountry';

export const countryPageRoute = (
  store: Store<GlobalState>,
  urlResolver: UrlResolver,
  getComponents: unknown,
) => {
  const { newCountryGuide } = getFeatureFlags(store.getState());

  if (newCountryGuide !== 'on') {
    return undefined;
  }

  const currentLanguage = getCurrentLanguageCode(store.getState());

  return {
    path: `${encodeURIComponent(
      COUNTRIES_TRANSLATED[currentLanguage],
    )}/:country(/)(:category)`,
    onEnter: onEnterCountry(store),
    getIndexRoute: getIndexRouteCountry(store, urlResolver, getComponents),
  };
};
